module.exports = __webpack_public_path__ + "img/about4.acddaba2.jpg";